export type ServerType = 0 | 1;

export type CardClass = "S" | "M" | "G";

export interface Card {
  name: string;
  class: CardClass;
}

export interface Server {
  id: number;
  type: ServerType;
  level: number;
  name: string;
  cards: Card[];
  imagePath: string;
  v3ImagePath: string | null;
}

export type Position = 1 | 2 | 3 | 4 | 5 | 6;
export type Address = "A" | "B" | "C";

export const POSITIONS: Position[] = [1, 2, 3, 4, 5, 6];
export const ADDRESSES: Address[] = ["A", "B", "C"];
